import React, {useEffect} from 'react';

import {PromotedSponsorshipModuleProps} from "../models/promoted-sponsorship-module.props";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {PromotedSponsorshipModuleController} from "../promoted-sponsorship-module.controller";
import {Image} from "../../../core/components/image/image";
import {PROMOTED_SPONSORSHIP} from "../promoted-sponsorship-module.consts";
import classNames from "classnames";
import styles from "../styles/promoted-sponsorship.module.scss"
export class PromotedSponsorshipModuleComponentProps extends PromotedSponsorshipModuleProps {}

export const PromotedSponsorshipModuleComponent = (({controller}: PromotedSponsorshipModuleComponentProps) => {
  const {state, device} = controller;
  const {isSmallView} = device;
  const {isVisible, sponsorship} = state;

  useEffect(() => {
    if(isVisible) {
      controller.action(PROMOTED_SPONSORSHIP.ACTION_TYPES.sponsorshipShow);
    }
  }, []);

  const imageProps = {
    src: sponsorship?.logo,
    className: classNames(styles.logo,{[styles.small_logo]: isSmallView}),
    onClick: () => {
      controller.action(PROMOTED_SPONSORSHIP.ACTION_TYPES.sponsorshipClick, {url: sponsorship?.externalUrl});
    },
  };

  return <Image {...imageProps} />
});

const settings: ComposeSettings = {
  component: PromotedSponsorshipModuleComponent,
  propsType: PromotedSponsorshipModuleComponentProps,
  controllerType: PromotedSponsorshipModuleController,

  observe: true,
  createModule: true,
};

export default Compose(settings);
